// --- Déclarations des vendors ---

// Setup des fonctionnalités du site construites avec Jquery (si possible travailler au dessu en vanilla JS
(function() {
    'use strict';
    jQuery(document).ready(function() {
        console.log('js loaded !');

        // Menu mobile
        if($('#menuToggle').length){
          $('#menuToggle').on('click', function(e){
            e.preventDefault();
            $('#header').toggleClass('active');
          });
        }

        // menu desktop
        function sticky(){
          if ($(window).scrollTop() > 0) {
            $('#header').addClass('sticky');
          } else {
            $('#header').removeClass('sticky');
          }
        }
        $(window).scroll(sticky);
        sticky();



        // flèche bas home
        if($('#homepageArwb').length){
          $('#homepageArwb').on('click', function(e){
            e.preventDefault();
            console.log('homepageArwb found');
            var targetOffsetTop = $('#homepageFirstBloc').offset().top;
            $('html,body').animate({scrollTop:targetOffsetTop}, 600);
          });
        }

        // Countdown home
        if($('#homepageTeaserTimer').length){

            var getCountDownDate = $('#homepageFirstBloc').attr('data-date');
            // Set the date we're counting down to
            var countDownDate = new Date("Oct 14, 2025 20:00:00").getTime();

            // Update the count down every 1 second
            var x = setInterval(function() {

              // Get today's date and time
              var now = new Date().getTime();

              // Find the distance between now and the count down date
              var distance = countDownDate - now;

              // Time calculations for days, hours, minutes and seconds
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              var seconds = Math.floor((distance % (1000 * 60)) / 1000);

              if(days.toString().length === 1){
                days = '0' + days;
              }
              if(hours.toString().length === 1){
                hours = '0' + hours;
              }
              if(minutes.toString().length === 1){
                minutes = '0' + minutes;
              }
              if(seconds.toString().length === 1){
                seconds = '0' + seconds;
              }

              // Display the result in the element with id="demo"
              document.getElementById("homepageTeaserTimer").innerHTML = '<span class="nb">' + days + '</span><span class="unit">j</span> <span class="nb">' + hours + '</span><span class="unit">h</span> <span class="nb">'
              + minutes + '</span><span class="unit">mn</span> <span class="nb">' + seconds + '</span><span class="unit last">s</span>';

              // If the count down is finished, write some text
              if (distance < 0) {
                clearInterval(x);
                document.getElementById("homepageTeaserTimer").innerHTML = "";
              }
            }, 1000);
        }


    });
})();
 